import NavLink from '../shared/buttons/nav-link';
import { PaymentType } from '../../api/payment';
import Segment from '../shared/segment';

export type PaymentVerifyPropsType = {
  code: string;
  payment: PaymentType;
};

function PaymentVerify({ payment, code }: PaymentVerifyPropsType) {
  return (
    <Segment color='green' textAlign='center' className='text-xl'>
      {payment.status && ['100', '101'].includes(code) ? (
        code === '100' ? (
          <p>بسته‌های موردنظر شما با موفقیت خریداری گردید.</p>
        ) : (
          <p>تراکنش با موفقیت انجام شده است.</p>
        )
      ) : (
        <p>متاسفانه تراکنش ناموفق بود.</p>
      )}
      <p className='my-1'>
        <span>شماره تراکنش خرید: </span>
        <span>{payment.result.refId}</span>
      </p>
      <NavLink to='/exams' color='green' content='بازگشت' className='mx-auto my-6' />
    </Segment>
  );
}

export default PaymentVerify;
